import * as React from 'react'
import { ReactElement, useEffect, useState } from 'react'
import { Route, RouteComponentProps, Switch } from 'react-router'
import TimeOverview from '../v2/pages/Time/TimeOverview'
import GlobalTimeOverview from '../v2/pages/Time/GlobalTimeOverview'
import EntityPage, { EntityPageProps, ParentProps } from './EntityPage'
import GlobalTimeSuggestionOverview from './Time/GlobalTimeSuggestionOverview'
import TimeSuggestionOverview from './Time/TimeSuggestionOverview'
import { MutationAction, MutationRouteMatchProps } from './BaseMutableOverview/BaseMutableOverview'
import { useRouteMatch } from 'react-router-dom'

export const timeBaseUrl = '/time/:action?'

export default function Times(props: EntityPageProps): ReactElement {
    const routeMatch = useRouteMatch<MutationRouteMatchProps>()

    const [openMutationDialog, setOpenMutationDialog] = useState(false)
    useEffect(() => setOpenMutationDialog(routeMatch.params.action === MutationAction.ADD), [routeMatch])

    return (
        <EntityPage {...props} baseUrl={timeBaseUrl}>
            {({ route, baseUrl }: ParentProps) => (
                <Switch>
                    <Route
                        exact
                        path={`${route}/suggestion`}
                        render={(routeProps: RouteComponentProps) =>
                            props.currentFile === undefined ? (
                                <GlobalTimeSuggestionOverview baseUrl={baseUrl} />
                            ) : (
                                <TimeSuggestionOverview
                                    {...routeProps}
                                    {...props}
                                    fileId={props.currentFile?.id}
                                    baseUrl={baseUrl}
                                    localStorageKeyPrefix={`HammockTimeSuggestionOverview-${props.currentFile.id}-`}
                                />
                            )
                        }
                    />
                    <Route
                        path={route}
                        render={(routeProps: RouteComponentProps) =>
                            props.currentFile === undefined ? (
                                <GlobalTimeOverview
                                    baseUrl={baseUrl}
                                    openMutationDialog={openMutationDialog}
                                    setOpenMutationDialog={setOpenMutationDialog}
                                />
                            ) : (
                                <TimeOverview
                                    {...routeProps}
                                    {...props}
                                    fileId={props.currentFile?.id}
                                    baseUrl={baseUrl}
                                    localStorageKeyPrefix={`HammockTimeOverview-${props.currentFile.id}-`}
                                    openMutationDialog={openMutationDialog}
                                    setOpenMutationDialog={setOpenMutationDialog}
                                />
                            )
                        }
                    />
                </Switch>
            )}
        </EntityPage>
    )
}
